import client, { PaginatedResponse, Response } from './client';
import { IBlockedPhoneNumber, ICustomer, ICustomerDetails } from '../../types/customer';
import qs from 'qs';

export type SearchCustomersParams = {
  phone_number: string;
};

export type TogglePhoneNumberBlockParams = {
  phone_number: string;
};

export type LoadBlockedPhoneNumbersParams = {
  page: number;
  filter: {
    phone_number?: string;
  };
};

export const searchCustomers = (
  storeId: string,
  params: SearchCustomersParams,
): Response<ICustomer[]> => client.get(`/stores/${storeId}/customers`, { params });

export const loadCustomerDetails = (
  storeId: string,
  params: SearchCustomersParams,
): Response<ICustomerDetails> => client.get(`/stores/${storeId}/customers/details`, { params });

export const loadBlockedPhoneNumbers = (
  params: LoadBlockedPhoneNumbersParams,
): PaginatedResponse<IBlockedPhoneNumber> =>
  client.get(`/blocked-phone-numbers`, { params, paramsSerializer: qs.stringify });

export const blockPhoneNumber = (data: TogglePhoneNumberBlockParams): Response<[]> =>
  client.post(`/blocked-phone-numbers`, data);

export const unblockPhoneNumber = (params: TogglePhoneNumberBlockParams): Response<[]> =>
  client.delete(`/blocked-phone-numbers`, { params });
